import apiService from "../../../../../api/rest";
import AppFavoriteNotifier from "@/components/base/app-favorite-notifier/AppFavoriteNotifier.vue";

const ADD_FAVORITE_SUCCESS_MSG = "Item added to favorites!";
const ADD_FAVORITE_ERROR_MSG = "Item could not be added to your favorites";
const REMOVE_FAVORITE_ERROR_MSG = "Item could not be removed from your favorites";

export const getDefaultState = () => {
  return {
    favoriteItemsIds: []
  };
};

// initial state
export const state = getDefaultState();

// getters
const getters = {
  getFavoriteItems(state, getters, rootState, rootGetters) {
    return rootGetters["vendor/getAllItems"].filter((item) =>
      state.favoriteItemsIds.find((favId) => item.id.toString() === favId.toString())
    );
  },
  isFavorite(state) {
    return (itemId) => state.favoriteItemsIds.indexOf(itemId.toString()) > -1;
  }
};

// actions
const actions = {
  async fetchFavoriteItemsIds({ commit, rootGetters }) {
    const visitorId = rootGetters["user/getVisitorId"];
    const domainId = rootGetters["common/getDomainId"];
    if (!visitorId || !domainId) return;

    try {
      commit("clearFavoriteItemsIds");
      const {
        data: { favorite_items = [] }
      } = await apiService.fetchFavorites(visitorId, domainId);

      commit("setFavoriteItemsIds", favorite_items);
      return Promise.resolve();
    } catch (reject) {
      return Promise.reject(reject.response);
    }
  },
  updateFavorites({ getters, dispatch }, itemId) {
    if (getters["isFavorite"](itemId)) {
      return dispatch("removeFavorite", itemId);
    }

    return dispatch("addFavorite", itemId);
  },
  addFavorite({ commit, rootGetters, dispatch }, itemId) {
    const visitorId = rootGetters["user/getVisitorId"];
    const domainId = rootGetters["common/getDomainId"];
    if (!visitorId || !domainId) return;

    return apiService.addFavorite(itemId, visitorId, domainId).then(
      () => {
        commit("addFavoriteId", itemId.toString());

        const msgObj = {
          message: ADD_FAVORITE_SUCCESS_MSG,
          componentName: AppFavoriteNotifier.name
        };

        dispatch("messages/addMessage", msgObj, { root: true });
      },
      (reject) => {
        const msgObj = {
          message: ADD_FAVORITE_ERROR_MSG,
          componentName: AppFavoriteNotifier.name
        };

        dispatch("messages/addMessage", msgObj, { root: true });

        return Promise.reject(reject);
      }
    );
  },
  removeFavorite({ commit, rootGetters, dispatch }, itemId) {
    const visitorId = rootGetters["user/getVisitorId"];
    const domainId = rootGetters["common/getDomainId"];
    if (!visitorId || !domainId) return;

    return apiService.removeFavorite(itemId, visitorId, domainId).then(
      () => {
        commit("removeFavoriteId", itemId.toString());
      },
      (reject) => {
        const msgObj = {
          message: REMOVE_FAVORITE_ERROR_MSG,
          componentName: AppFavoriteNotifier.name
        };

        dispatch("messages/addMessage", msgObj, { root: true });

        return Promise.reject(reject);
      }
    );
  },
  cleanFavorites({ commit }) {
    commit("clearFavoriteItemsIds");
  }
};

// mutations
const mutations = {
  setFavoriteItemsIds(state, itemsIds) {
    state.favoriteItemsIds = itemsIds.map((item) => item.item_id);
  },
  clearFavoriteItemsIds(state) {
    state.favoriteItemsIds = [];
  },
  addFavoriteId(state, itemId) {
    state.favoriteItemsIds.push(itemId);
  },
  removeFavoriteId(state, itemId) {
    const index = state.favoriteItemsIds.indexOf(itemId);
    state.favoriteItemsIds.splice(index, 1);
  },
  resetFavoritesState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
